import {
  FormHelperText,
  Grid,
  Stack
} from '@mui/material';

import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomButton from '../elements/CustomButton';
import InputField from '../elements/InputField';

const ForgotPasswordForm = ({ onSubmit }) => {
  return (
    <>
      <Formik
        initialValues={{
          email: '',
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string('Enter your email')
            .email('Invalid email address')
            .max(255)
            .required('Email is required'),
        })}
        onSubmit={onSubmit}>
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputField
                    label="Email Address"
                    id="email"
                    type="email"
                    value={values.email}
                    name="email"
                    fullWidth
                    placeholder="Enter email address"
                    error={Boolean(touched.email && errors.email)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Stack>
              </Grid>
              {errors.submit && (
                <Grid item xs={12}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
              )}
              <Grid item xs={12}>
                <CustomButton buttonLabel={'Submit'} />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ForgotPasswordForm;
